import BaseRepository from './BaseRepository';
export default class
    extends BaseRepository
{
    getEndpoint()
    {
        return 'v1/travel-agencies';
    }

    getByIdentifier(data)
    {
        return this.request('GET', `${this.getEndpoint()}/get-by-identifier/${data.identifier_type}/${data.identifier_number}`, data);
    }
}
